import * as actionLog from '../src/actionLog.js';

export default {
    install(app, options) {
        app.config.globalProperties.$actionLog = actionLog;
    }
}
